import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-menu',
    templateUrl: 'menu.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class MenuComponent {
    constructor() {

    }
}
